import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Button, Stack, Tooltip, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { leadDataSelector } from "../../slices/selectors";
const TraceIdButton = () => {
  const { enquiry_id: enquiryId } = useSelector(leadDataSelector);
  return (
    <Button
      sx={{
        height: "2.25rem",
        textTransform: "capitalize",
        cursor: "pointer",
        borderColor: "var(--primary-color) !important",
      }}
      onClick={() => {
        navigator.clipboard.writeText(enquiryId);
        toast.success(
          <div style={{ fontSize: ".8rem", fontWeight: "600" }}>
            Copied to clipboard
          </div>
        );
      }}
      variant="outlined"
    >
      <Stack spacing={0.5} direction={"row"} alignItems={"center"}>
        <Typography
          sx={{
            fontSize: ".8rem",
            marginRight: "10px",
            color: "black",
            display: "flex",
          }}
        >
          CRN / Trace ID :{" "}
          <Typography
            sx={{
              fontSize: ".8rem",
              marginLeft: "10px",
              color: "var(--primary-color)",
              display: "flex",
            }}
          >
            {enquiryId}
          </Typography>
        </Typography>
        <Tooltip
          title="Copy to clipboard"
          arrow
          enterTouchDelay={0}
          leaveTouchDelay={2000}
        >
          <ContentCopyIcon
            sx={{
              fontSize: "1rem",
              marginLeft: "10px",
              color: "grey",
            }}
          />
        </Tooltip>
      </Stack>
    </Button>
  );
};

export default TraceIdButton;
